import { Card } from "@mui/material";
import StripePricesTable from "./components/StripePricesTable";

function StripePricesApp() {
	return (
		<div className="w-full p-[20px]">
			<div className="flex flex-col gap-[20px]">
				<Card className="p-[28px] overflow-auto">
					<StripePricesTable />
				</Card>
			</div>
		</div>
	);
}

export default StripePricesApp;
